<template>
  <div class="contents userMgt">
    <div class="title flexB">
      <h2>스토어 관리</h2>
    </div>
    <div class="box one filter">
      <div class="flex">
        <p class="bold">검색조건</p>
        <select v-model="inputMode">
          <option value="" selected disabled>선택</option>
          <option value="title">상품명</option>
          <option value="content">상품정보</option>
          <option value="seller">브랜드</option>
        </select>
        <input type="text" v-model="searchWord" @keyup.enter="search" />
      </div>
      <div class="flex">
        <p class="bold">카테고리</p>
        <label>
          <input type="radio" value="" checked v-model="category" />전체
        </label>
        <label>
          <input type="radio" value="WEDDING" v-model="category" />
          웨딩패키지
        </label>
        <label>
          <input type="radio" value="BEAUTY" v-model="category" />
          뷰티
        </label>
        <label>
          <input type="radio" value="GIFT" v-model="category" />
          답례품
        </label>
        <label>
          <input type="radio" value="TRAVEL" v-model="category" />
          여행
        </label>
        <label>
          <input type="radio" value="ACTIVITY" v-model="category" />
          액티비티
        </label>
        <label>
          <input type="radio" value="CLASS" v-model="category" />
          원데이클래스
        </label>
        <label>
          <input type="radio" value="ETC" v-model="category" />
          기타
        </label>
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>

    <div class="box one">
      <h2 class="bold">
        스토어 리스트
        <button class="right basic">
          <router-link to="/admin/storemanage/register"
            >스토어 등록</router-link
          >
        </button>
      </h2>
      <table>
        <colgroup>
          <col style="width: 8%" />
          <col style="width: 10%" />
          <col style="width: 15%" />
          <col style="width: 12%" />
          <col style="width: 28%" />
          <col style="width: 12%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>카테고리</th>
          <th>상품명</th>
          <th>브랜드명</th>
          <th>상품정보</th>
          <th class="right">가격</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in storeList" :key="i">
          <td>{{ total + 1 - (i + 1 + (currentPage - 1) * 10) }}</td>
          <td>
            {{
              data.category == "WEDDING"
                ? "웨딩패키지"
                : data.category == "BEAUTY"
                ? "뷰티"
                : data.category == "GIFT"
                ? "답례품"
                : data.category == "TRAVEL"
                ? "여행"
                : data.category == "ACTIVITY"
                ? "액티비티"
                : data.category == "CLASS"
                ? "원데이클래스"
                : data.category == "ETC"
                ? "기타"
                : ""
            }}
          </td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.title
            }}</router-link>
          </td>
          <td>{{ data.seller }}</td>
          <td>{{ data.content }}</td>
          <td class="right">{{ numberFormat(data.price) }}원</td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-if="storeList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { fetchStoreList } from "@/api/admin";
import NoData from "@/components/contents/Nodata";
import { format } from "@/mixins/format";
export default {
  name: "toymanage",
  mixins: [format],
  components: { NoData },
  data() {
    return {
      moment: moment,
      category: "",
      storeList: [],
      inputMode: "",
      searchWord: "",
      total: 0,
      currentPage: 1,
      isNodata: false,
    };
  },
  computed: {
    ...mapState(["navbarState"]),
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "4");
  },
  mounted() {
    this.getStoreList();
  },
  methods: {
    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.category = "";
      this.currentPage = 1;
      this.storeList = [];
      this.total = 0;
      this.getStoreList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        this.$alert("검색 조건을 선택해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
        return;
      }
      this.getStoreList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getStoreList();
    },
    handleMove(id) {
      this.$router.push({ name: "storeregister", query: { id: id } });
    },
    getStoreList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        inputMode: this.inputMode,
        category: this.category,
      };
      fetchStoreList(params).then((res) => {
        if (res.data.status == 200) {
          this.storeList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
        } else {
          this.$alert(res.data.message, {
            confirmButtonText: "확인",
            center: true,
          });
        }
      });
    },
  },
};
</script>
